import React, { useEffect, useState, useContext } from 'react';
import Navbar from '../navigation/Navbar';
import Footer from '../navigation/Footer';
import ReactModal from 'react-modal';
import { useModal } from 'react-modal-hook';
import SelectCountryModal from '../modals/SelectCountryModal';
import { UserContext } from '../context/AuthContext';

const SUPPORTED_COUNTRY_IDS = [112, 17, 107]; // Kuwait, Bahrain, Jordan

function PageLayout(props) {
    const { loggedIn, user, loadingUser } = useContext(UserContext);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [show]);

    const [openSelectCountryModal, closeSelectCountryModal] = useModal(() => {
        setShow(true);
        return (
            <ReactModal isOpen ariaHideApp={false} className="react_modal" overlayClassName="modal_overlay">
                <SelectCountryModal closeModal={closeSelectCountryModal} setShow={setShow} />
            </ReactModal>
        );
    });

    useEffect(() => {
        if (!loadingUser && loggedIn && user && user.country_id && !SUPPORTED_COUNTRY_IDS.includes(user.country_id)) {
            openSelectCountryModal();
        }
    }, [loadingUser, loggedIn, user, openSelectCountryModal]);

    return (
        <>
            <Navbar me={props.me} />
            {props.children}
            <Footer />
        </>
    );
}

export default PageLayout;
